import { render } from "./uiNavList.vue?vue&type=template&id=12aca692"
import script from "./uiNavList.vue?vue&type=script&lang=js"
export * from "./uiNavList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__